import React from 'react'
import { Row } from 'react-bootstrap';
import { IKidsComboModifierItem, IModifierGroups } from '../../../models/kidsCombo';
import KidsComboItemListing from './KidsComboChoseAnItem';
import NestedModifiersView from './NestedModifiers';
import styeleClasses from '../ItemSelection/kidsCombo.module.scss'


interface IChoseItemModalContent {
    itemStack: IKidsComboModifierItem[];
    modifierGroup: any;
    requiredItemAsModifier: any;
    selectedModifierAsItemsIds: any;
    isCustomizing: boolean;
    nonActiveSelectedModifierAsItemId: any;
    handleItemRemoval: (item: any, index: any) => void;
    pushToItemStack:(item: IKidsComboModifierItem, type: string, isFirstSelection?: boolean) => void;
    modifierGroupsQueue: IModifierGroups[];
    selectedItemId: any;
    handleIngredientSelection: any;
    parentNestedId: any;
    orderType: string;
}

const ChoseItemModalContent:React.FC<IChoseItemModalContent> = (props) => {
    const { 
        itemStack, 
        modifierGroup, 
        requiredItemAsModifier, 
        selectedModifierAsItemsIds, 
        isCustomizing, 
        nonActiveSelectedModifierAsItemId, 
        handleItemRemoval, 
        pushToItemStack, 
        modifierGroupsQueue, 
        selectedItemId, 
        handleIngredientSelection, 
        parentNestedId, 
        orderType
    } = props;
    const isBasicSelectionOnce = !(itemStack?.length && Object.keys(modifierGroup).length);

    return (
        <>
            <Row>
                {isBasicSelectionOnce &&
                    requiredItemAsModifier.map((requiredItem, index) => {
                        let selected = requiredItem?.is_selected;
                        const isFirstSelection = Boolean(!selected && itemStack?.length);
                        if (isFirstSelection)
                            selected = itemStack.at(0)?.id === requiredItem.id;
                        const disabledSelectedItem =
                            (selectedModifierAsItemsIds.includes(requiredItem.id) &&
                                !isCustomizing) ||
                            nonActiveSelectedModifierAsItemId?.id === requiredItem?.id;

                        return (
                            <KidsComboItemListing
                                key={requiredItem.id}
                                disabledSelectedItem={disabledSelectedItem}
                                selected={selected}
                                isFirstSelection={isFirstSelection}
                                handleItemRemoval={handleItemRemoval}
                                index={index}
                                requiredItem={requiredItem}
                                pushToItemStack={pushToItemStack}
                                orderType={orderType}
                            />
                        );
                    })}
            </Row>
            {itemStack?.length && Object.keys(modifierGroup).length ? (
                <>
                    {/* <hr className="my-y" /> */}
                    <div>
                        <h6 className="font-Cls ls-normal mb-0 f-s22 text-start">
                            {modifierGroup?.label}
                        </h6>
                    </div>
                    <Row className={styeleClasses.kids_item_modal_view}>
                        {modifierGroup?.modifiers_groups_modifiers?.map((modifier) => (
                            <NestedModifiersView
                                key={modifier.id}
                                modifier={modifier}
                                modifierGroup={modifierGroup}
                                modifierGroupsQueue={modifierGroupsQueue}
                                selectedItemId={selectedItemId}
                                handleIngredientSelection={handleIngredientSelection}
                                pushToItemStack={pushToItemStack}
                                nestedParentId={parentNestedId}
                                orderType={orderType}
                            />
                        ))}
                    </Row>
                </>
            ) : (
                ""
            )}
        </>
    )
}

export default ChoseItemModalContent